import { createContext, useContext, useState, useCallback } from "react";

const ToastContext = createContext(null);

let toastSeq = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const notify = useCallback((message, type = "info") => {
    const id = ++toastSeq;
    setToasts((prev) => [...prev, { id, message, type }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 3000);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const mappedType = (type) => {
    switch (type) {
      case "success":
        return "success";
      case "error":
        return "danger";
      case "warning":
        return "warning";
      default:
        return "info";
    }
  };

  return (
    <ToastContext.Provider value={{ notify }}>
      {children}
      <div className="position-fixed top-0 end-0 m-3 z-5" aria-live="polite">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`alert alert-${mappedType(toast.type)} alert-dismissible fade show`}
            role="alert"
          >
            {toast.message}
            <button
              type="button"
              className="btn-close"
              onClick={() => removeToast(toast.id)}
            ></button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
}
